<template>
  <div ref="dhVideo" id="dh-video" class="dh-video">
      <object
        id="dhTest"
        classid="CLSID:D3E383B6-765D-448D-9476-DFD8B499926D"
        style="position: absolute;top: -999999px;left:-99999px"
        codebase="DpsdkOcx.cab#version=1.0.0.0"
      ></object>
    <div v-if="!isSupportDH" class="wrap-tip">
        <div class="wrap-content">
            <div class="wrap-xiazai" style="color:#999;font-size: 12px;">建议使用IE, 360极速或安全浏览器的兼容模式查看</div>
        </div>
    </div>
    <div class="dh-video-container" id="obj" v-else>
      <object
        :id="md5"
        classid="CLSID:D3E383B6-765D-448D-9476-DFD8B499926D"
        style="width: 100%; height: 80%"
        codebase="DpsdkOcx.cab#version=1.0.0.0"
      ></object>
    </div>
  </div>
</template>

<script>
import { hex_md5 } from "./../utils/md5";
import { IS_CHROME, IS_EDGE } from "./../utils/browser";
// import axios from "axios";
import axios from "./axios";

export default {
  name: "DHVideo",
  props: {
    code: String,
    config: {
      type: Object,
      default: () => {
        return {
          streamType: '1', // 1 主码流 2 副码流
          mediaType: '1', // 1 视频 2 音频 3 视频 + 音频
          transType: '1', // 1 TCP 0 UDP
        };
      },
    },
  },
  watch: {
    code: {
      async handler(nVal) {
        if (!nVal) {
          console.log("请提供大华通道ID播放！");
          return;
        }

        this.md5 = hex_md5(nVal);

        this.init();
      },
      immediate: true,
    },
  },
  data() {
    return {
      IS_CHROME,
      isSupportDH: false,
      dhObj: null, // 大华视频对象
      dhWndID: null, // 大华句柄ID
      ip: '', // ip
      port: '', // port
      username: '', // username
      password: '', // password
      md5: '', // code md5 用于区分多实例
      ownerDhCode: null, // 私有code
    }
  },
  mounted() {
    this.isSupportDH = this.checkDHPlugin();
    console.log("当前浏览器是否支持DH", this.isSupportDH)
  },
  methods: {
    checkDHPlugin() {
      var dhObj = document.getElementById('dhTest');
      let result = false;
      try {
        dhObj.DPSDK_CreateSmartWnd(0, 0, 1, 1);
        result = true;
      } catch (error) {
        result = false;
        console.log(error);
      }
      return result;
    },
    init() {
      if (!this.code) {
        console.error("请提供code播放")
        return ;
      }
      this.md5 = hex_md5(this.code);

      if (this.config && this.config.ip && this.config.port) {
        this.ip = this.config.ip;
        this.port = this.config.port;
        this.username = this.config.username;
        this.password = this.config.password;
        this.$nextTick(() => {
          this.startRegisterOCX();
        })
      } else {
          /**
           * 此处0.4.6版本开始 携带code参数 兼容新版后台
           */
          const url =
            this.configUrl && this.configUrl.getDHConfigUrl
              ? this.configUrl.getDHConfigUrl
              : "/api/iot/getHKvideoSerect";
          const params = {
            code: this.code,
          };
          axios
            .post(url, params)
            .then((res) => {
              if (res.data.status === 200 && res.data.code === 200) {
                this.ip = res.data.result.ip;
                this.port = res.data.result.port;
                this.username = res.data.result.username;
                this.password = res.data.result.password;
                this.$nextTick(() => {
                  this.startRegisterOCX();
                })
              } else {
                console.error("接口请求错误！");
              }
            })
            .catch((err) => {
              console.error("接口请求错误！", err);
            });
      }
    },
    // OCX业务逻辑开始
    startRegisterOCX() {
      console.log(this.$refs.dhVideo)
      console.log(this.$refs.dhVideo.getBoundingClientRect())
      this.dhObj = document.getElementById(this.md5);
      const domRect = this.$refs.dhVideo.getBoundingClientRect();
      // 创建窗口
      this.dhWndID = this.dhObj.DPSDK_CreateSmartWnd(0, 0, domRect.width, domRect.height);
      // 设置窗口数量
      this.dhObj.DPSDK_SetWndCount(this.dhWndID, 1);
      this.dhObj.DPSDK_SetSelWnd(this.dhWndID, 0);
      //初始化后设置日志路径
      this.dhObj.DPSDK_SetLog(2, "D:\\DPSDK_OCX_log", false, false);
      // 按钮UI
      this.dhObj.DPSDK_SetToolBtnVisible(1, false); // 1 audio button
      this.dhObj.DPSDK_SetToolBtnVisible(2, false); // 2 talk button
      this.dhObj.DPSDK_SetToolBtnVisible(3, false); // 3 localRecord button
      this.dhObj.DPSDK_SetToolBtnVisible(4, false); // 4 cappicture button 
      this.dhObj.DPSDK_SetToolBtnVisible(7, false); // 7 add focus
      this.dhObj.DPSDK_SetToolBtnVisible(9, false); // 9 reduce focus
      this.dhObj.DPSDK_SetControlButtonShowMode(1, 0); // 1 toolbar上的按钮
      this.dhObj.DPSDK_SetControlButtonShowMode(2, 0); // 2 云台控制按钮
      this.login().then(res=>{
        this.play();
      }).catch(err=>{
        console.error("登录失败", err);
      })
    },
    // 登录
    login() {
      return new Promise((resolve, reject) => {
        console.log(this.ip, this.port, this.username, this.password)
        var nRet = this.dhObj.DPSDK_Login(this.ip, this.port, this.username, this.password);
        if (nRet == 0) {
          resolve();
        } else {
          reject(nRet);
        }
      })
    },
    // 播放
    play() {
      if (!this.code) {
        console.error("请提供视频编码播放")
        return;
      }
      const streamType = this.config.streamType ? this.config.streamType : '1'
      const mediaType = this.config.mediaType ? this.config.mediaType : '1'
      const transType = this.config.transType ? this.config.transType : '1'
      var nWndNo = this.dhObj.DPSDK_GetSelWnd(this.dhWndID);
      var nRet = this.dhObj.DPSDK_StartRealplayByWndNo(this.dhWndID, nWndNo, this.code, streamType, mediaType, transType);
      if(nRet != 0)
      {
        console.error("播放失败" + nRet);
      }
    },
    // 获取播放器核心对象
    getCore() {
      return this.dhObj;
    },
    // 销毁对象
    dispose() {
      var nWndNo = this.dhObj.DPSDK_GetSelWnd(this.dhWndID);
      this.dhObj.DPSDK_StopRealplayByWndNo(this.dhWndID, nWndNo)
    }
  }
};
</script>

<style lang="scss" scoped>
.dh-video {
  z-index: 1;
  width: 100%;
  height: 100%;
  &-container {
    width: 100%;
    height: 100%;
  }
  .wrap-tip {
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #e7e9ed;
    .wrap-content {
      .wrap-xiazai {
        display: flex;
        justify-content: center;
      }
    }
  }
}
</style>